exports = module.exports = require("./../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "h1{font-family:Roboto,Helvetica,Arial,sans-serif;font-size:4.3vmin;font-weight:500;line-height:9vmin}h1,h2{margin:0}h2{font-family:Roboto Condensed,Arial Narrow,Helvetica,Arial,sans-serif;font-size:3.5vmin;font-weight:400}map-gallery{display:block;width:100%;height:100%}map-gallery .map-gallery{width:90%;padding:0 5%;height:99%}map-gallery .map-gallery .image-wrapper{height:100%}map-gallery .map-gallery .image-wrapper .image{display:inline-block;float:left;position:relative;height:100%;width:70%;max-width:100%;background-size:contain!important;background-position:50%!important;background-repeat:no-repeat!important}map-gallery .map-gallery .image-wrapper .image .content{position:absolute;width:100%;height:100%}map-gallery .map-gallery .image-wrapper .image .error,map-gallery .map-gallery .image-wrapper .image .loading{position:absolute;width:100%;height:100%;left:0;top:0;background-color:#000;text-align:center;font-size:5.5vmin}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./client/app/components/common/mapGallery/mapGallery.scss
 ** module id = 240
 ** module chunks = 0
 **/